// @ts-ignore
export * as namespaceMapping from '../common/namespaceMapping'
export * as newSchemaService from './newSchemaService'
export * as newSchemas from './configs/newSchemas'
export * as restrictiveSchemas from './configs/restrictiveSchemas'
export * as schemas from './configs/schemas'
export * as schemaArrangement from './schemaArrangement'
export * as componentTypeAliases from './schemas/componentTypeAliases'
export * as skinsByComponentType from './schemas/skinsByComponentType'
export * as schemaConfigs from './configs/schemaConfigs'
export * as schemaUtils from './schemas/schemaUtils'
export * from '../build/enums-convertor'
//Used by @wix-private/dm-server
export {convertNamespaceToAbsoluteUrn} from '../common/convertNamespaceToAbsoluteUrn'
